module.exports = __webpack_public_path__ + "img/art-49.60772e82.png";